import { render, staticRenderFns } from "./topicChange.vue?vue&type=template&id=d071c43c&scoped=true&"
import script from "./topicChange.vue?vue&type=script&lang=js&"
export * from "./topicChange.vue?vue&type=script&lang=js&"
import style0 from "./topicChange.vue?vue&type=style&index=0&id=d071c43c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d071c43c",
  null
  
)

export default component.exports